// import jsonp from 'assets/js/jsonp'
// import {
//   commonParams,
//   options
// } from './config'
import axios from 'axios';
import { Promise } from 'core-js';
import {HOSTURL} from './config'

export function getHotKey() {
  // const url = 'https://c.y.qq.com/splcloud/fcgi-bin/gethotkey.fcg'

  // const data = Object.assign({}, commonParams, {
  //   uin: 0,
  //   needNewCode: 1,
  //   platform: 'h5'
  // })

  // return jsonp(url, data, options)
  const url = '/search/hot'

  return axios.get(`${HOSTURL}${url}`).then((res) => {
    return Promise.resolve(res.data);
  })
}

// 查询歌曲
export function search(query, page, zhida, perpage) {
  // const url = 'https://c.y.qq.com/soso/fcgi-bin/search_for_qq_cp'

  // const data = Object.assign({}, commonParams, {
  //   w: query,
  //   p: page,
  //   perpage,
  //   n: perpage,
  //   catZhida: zhida ? 1 : 0,
  //   zhidaqu: 1,
  //   t: 0,
  //   flag: 1,
  //   ie: 'utf-8',
  //   sem: 1,
  //   aggr: 0,
  //   remoteplace: 'txt.mqq.all',
  //   uin: 0,
  //   needNewCode: 1,
  //   platform: 'h5'
  // })

  // return jsonp(url, data, options)

  console.log(query)
  console.log(page)
  console.log(zhida)
  console.log(perpage)
  const url = '/search'

  const data = {
    keywords: query,
    limit: perpage,
    offset: page - 1
  }
  return axios.get(`${HOSTURL}${url}`, {
    params: data
  }).then((res) => {
    return Promise.resolve(res.data);
  })
}



// WEBPACK FOOTER //
// ./src/api/search.js